var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0H1.75C0.783502 0 0 0.783502 0 1.75V12.25C0 13.2165 0.783502 14 1.75 14H17.5C18.4665 14 19.25 13.2165 19.25 12.25V1.75C19.25 0.783502 18.4665 0 17.5 0Z",
    fill: "#333F48"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0H1.75C0.783502 0 0 0.783502 0 1.75V12.25C0 13.2165 0.783502 14 1.75 14H17.5C18.4665 14 19.25 13.2165 19.25 12.25V1.75C19.25 0.783502 18.4665 0 17.5 0Z",
    fill: "#333F48"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.5 4.375C-0.5 4.09886 -0.276142 3.875 0 3.875H19.25C19.5261 3.875 19.75 4.09886 19.75 4.375C19.75 4.65114 19.5261 4.875 19.25 4.875H0C-0.276142 4.875 -0.5 4.65114 -0.5 4.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.125 7C2.125 6.72386 2.34886 6.5 2.625 6.5H10.5C10.7761 6.5 11 6.72386 11 7C11 7.27614 10.7761 7.5 10.5 7.5H2.625C2.34886 7.5 2.125 7.27614 2.125 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.125 9.625C2.125 9.34886 2.34886 9.125 2.625 9.125H5.25C5.52614 9.125 5.75 9.34886 5.75 9.625C5.75 9.90114 5.52614 10.125 5.25 10.125H2.625C2.34886 10.125 2.125 9.90114 2.125 9.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 7C13.5 6.72386 13.7239 6.5 14 6.5H16.625C16.9011 6.5 17.125 6.72386 17.125 7C17.125 7.27614 16.9011 7.5 16.625 7.5H14C13.7239 7.5 13.5 7.27614 13.5 7Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon_card.44d02180ee46a0890ac260ba812ad960.svg";
export { ForwardRef as ReactComponent };